export function truncateMessagePreview(text: string, maxLength = 96): string {
  const trimmed = text.trim();
  if (trimmed.length <= maxLength) return trimmed;
  return `${trimmed.slice(0, maxLength - 1)}…`;
}

export function isFollowUpBusyForEntry(
  followUpLoadingId: string | null,
  targetMessageId: string,
): boolean {
  return (
    followUpLoadingId === targetMessageId ||
    (followUpLoadingId?.startsWith(`${targetMessageId}:`) ?? false)
  );
}

export function isFollowUpRegenerating(
  followUpLoadingId: string | null,
  targetMessageId: string,
  followUpId: string,
): boolean {
  return followUpLoadingId === `${targetMessageId}:${followUpId}`;
}
